import { render, staticRenderFns } from "./PublicationRenderer.vue?vue&type=template&id=2548d02a&scoped=true&"
import script from "./PublicationRenderer.vue?vue&type=script&lang=js&"
export * from "./PublicationRenderer.vue?vue&type=script&lang=js&"
import style0 from "./PublicationRenderer.vue?vue&type=style&index=0&id=2548d02a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2548d02a",
  null
  
)

export default component.exports